import { render, staticRenderFns } from "./UserTransactionList.vue?vue&type=template&id=5fc0c55c&scoped=true&"
import script from "./UserTransactionList.vue?vue&type=script&lang=js&"
export * from "./UserTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0c55c",
  null
  
)

export default component.exports